import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CustomValidators } from '../../../shared/services/custom.validators';
import { JwtAuthService } from '../../../shared/services/auth/jwt-auth.service';
import { NotificationService} from '../../../shared/services/notification.service';

@Component({
  selector: 'app-forgot-password-reset',
  templateUrl: './forgot-password-reset.component.html',
  styleUrls: ['./forgot-password-reset.component.scss']
})
export class ForgotPasswordResetComponent implements OnInit {

  pin;
  newPassword;
  newPasswordConfirm;
  form: FormGroup;
  @ViewChild(MatProgressBar) progressBar: MatProgressBar;
  @ViewChild(MatButton) submitButton: MatButton;
  constructor(
    private jwtAuth: JwtAuthService,
    private router: Router,
    private fb: FormBuilder,
    private notificationService: NotificationService,
  ) { 
    this.form = this.toForm();
  }

  ngOnInit() {
  }
  submit() {
    this.submitButton.disabled = true;
    this.progressBar.mode = 'indeterminate';
    this.jwtAuth.recoverPassReset(this.form.value).subscribe(res =>{
      this.notificationService.success("Ha cambiado su contraseña con exito !!!. Pruebe iniciar sesion nuevamente")
      this.router.navigateByUrl("/sessions/signin");
    });
  }

  private toForm(): FormGroup {
		return this.fb.group({
			pin: new FormControl('', Validators.required),
			newPassword: new FormControl('', Validators.required),
			newPasswordConfirm: new FormControl('', [Validators.required,CustomValidators.match('newPassword')])
		});
  }
  

}
